import { createSelector } from 'reselect';
export const getDataQueryVariables = state => {
  return state.resources.dataQueryVariables.dataQueryVariables;
};
const getDataQueryPathFromProps = (state, props) => props.dataQueryPath;
export const getDataQueryVariablesByPath = createSelector([getDataQueryVariables, getDataQueryPathFromProps], (dataQueryVariables, dataQueryPath) => {
  if (!dataQueryPath) return {};
  return dataQueryVariables[dataQueryPath] || {};
});